module.exports = __webpack_public_path__ + "img/sygnet.8c3d597.svg";